<template>
  <div>
    <div class="text-h6">{{ title }}</div>
    <div class="text-subtitle-1">{{ subtitle }}</div>

    <literal-value
      v-for="(v, index) in values"
      :literal="v"
      :highlights="[]"
      :key="index"
      class="text-body-1"
    ></literal-value>

    <literal-value
      :literal="coordinates"
      :highlights="[]"
      :encoding="'geocoord'"
    ></literal-value>

    <!--
    <div v-if="hasAddress">
      <div
        v-for="(line, index) of addressLines"
        :key="index"
        class="text-body-1"
      >
        {{ line }}
      </div>
    </div>
    <div v-else> -->
    <!-- Write all data properties as fallback if no address is present -->
    <!--
      <div v-for="(prop, index) of dataProps" :key="index" class="text-body-1">
        {{ prop.values[0].value }}
      </div>
    </div> -->
    <router-link
      :to="`/individual/${encodeURIComponent(this.id)}`"
      class="text-button secondary--text"
      >Details
    </router-link>
  </div>
</template>

<script>
// TODO the parsing of properties to address is really a WoB specfic thing and should reside with the wob client...
import humanizeString from 'humanize-string'

// TODO the info window is tied to a rec point individual not the postal address individual...
const AddressProps = {
  postalAddress: 'https://w3id.org/rec#addressLine1',
  zipCode: 'https://w3id.org/rec#postalCode',
  city: 'https://w3id.org/rec#city',
}

import LiteralValue from './LiteralValue.vue'
import { Iri } from '@/rec-cache/rec-cache-types'

export default {
  components: { LiteralValue },

  data: () => ({
    id: '',
    type: '',
    title: '',
    subtitle: '',
    coordinate: '',
    dataProps: [],
    coordinates: '',
    values: [],
  }),
  computed: {
    typeStr: function () {
      return humanizeString(this.type)
    },
    hasAddress: function () {
      return Object.values(AddressProps).reduce(
        (prev, curr) =>
          prev && this.dataProps.map((p) => p.name.value).includes(curr),
        true
      )
    },
    addressLines: function () {
      const lines = []
      // Postal address line.
      lines.push(
        this.dataProps.find((p) => p.name.value == AddressProps.postalAddress)
          ?.values[0].value
      )
      // Zip and City line.
      const zip = this.dataProps.find(
        (p) => p.name.value == AddressProps.zipCode
      )?.values[0].value
      const city = this.dataProps.find((p) => p.name.value == AddressProps.city)
        ?.values[0].value
      lines.push(`${zip} ${city}`)
      return lines
    },
  },
  created: function () {
    this.values = []
    const individual = this.$wob.read(new Iri(this.id), false)
    const entry = individual.getValuesByName(
      'https://webofbuildings.com/ontology/isEntryOf'
    )?.[0]
    const building = entry && this.$wob.read(entry, false)
    if (building) this.values.push(building.label)
    // console.log('INFO WINDOW', entry, building)
  },
  mounted: function () {},
  methods: {
    onClick: function () {
      this.$router.push(`/individual/${encodeURIComponent(this.id)}`)
    },
  },
}
</script>
